import { Link } from "react-router";
import style from './BreadCrumb.module.css';


export default function BreadCrumb(props) {


    return (
        <>
            <span>
                <Link className={style.breadcrumb} to={props.link} >
                    {props.name}
                    <span>{props.icon ? <i className=" ps-1 pe-1 bi bi-caret-right-fill"></i> : ""}</span>
                </Link>
            </span>

        </>
    )
}